// created by Mateusz Klimaszewski for COMBO demo

import React from 'react';
import { ExternalLink } from '@allenai/varnish/components';
import { withRouter } from 'react-router-dom';

import { API_ROOT } from '../../api-config';
import Model from '../Model'
import { Tree } from 'hierplane';

const title = "Natural language preprocessing";

const description = (
  <span>
      <a href="https://gitlab.clarin-pl.eu/syntactic-tools/combo">COMBO</a> is a new system for
      part-of-speech tagging, morphological analysis, lemmatisation, and dependency parsing, i.e.
      the basic language processing tasks. This demo uses a model trained on the
      <a href="https://github.com/UniversalDependencies/UD_English-EWT"> UD English-EWT </a>
      (<a href="https://www.aclweb.org/anthology/L14-1067">Silveira et al., 2014</a>).
      COMBO was created at <a href="http://ipipan.waw.pl/en/">ICS PAS</a> and is currently being
      developed in the project <a href="https://clarin.biz">CLARIN-PL-Biz</a>.
  </span>
);

const descriptionEllipsed = null;

const fields = [
    {name: "sentence", label: "Please enter a sentence", type: "TEXT_INPUT", placeholder: `i.e. "They will be sending the revised document to me."`},
];

const HierplaneVisualization = ({tree}) => {
    if (tree) {
        return (
            <div className="hierplane__visualization">
                <Tree tree={tree} theme="light" />
            </div>
        )
    } else {
        return null;
    }
};

const Output = ({ responseData }) => (
    <HierplaneVisualization tree={responseData.hierplane_tree} />
);

const examples = [
    "They will be sending the revised document to me.",
    "I'll be at your house around 10:30 or 11 tonight.",
    "T-Rex was a bipedal carnivore with a massive skull balanced by a long, heavy tail."
  ].map(sentence => ({sentence}));

const apiUrl = () => `${API_ROOT}/predict/combo-eng`;


const modelProps = {apiUrl, title, description, descriptionEllipsed, fields, examples, Output};

export default withRouter(props => <Model {...props} {...modelProps}/>)
